export const INTELLIGENCE_HEADER_ID = "yorkie-intelligence-header";
export const INTELLIGENCE_FOOTER_ID = "yorkie-intelligence-footer";
